<template>
  <div
    :class="
      'header-fix reset-password w-100 d-flex flex-column align-items-center split-layout-content' + (status === 200 ? 'success-change' : '')
    "
  >
    <img :src="require('@/assets/logos/kariyer_net_logo-white@2x.png')" class="responsive-logo" />
    <secure-password-steps v-if="isStepMode"></secure-password-steps>
    <form-wrapper
      v-else-if="status !== 200"
      class="reset-password-form"
      :isValid="isValid"
      :header-text="resource['resetPassword']"
      :desc="`<b>${userName ? userName : ''} </b>
    <br />
    <div style='margin-top:10px;font-size: 14px;'>${resource['resetPassword.CreatePassword']}</div>
`"
      href="/login"
      :button-text="resource['resetPassword.SavePassword']"
      type="resetPassword"
      :is-loading="isLoading"
      :enable-button="enableButton"
      :disabled="!confirmPassword || !isValid"
      :class="[{ 'animated fadeOut': status === 200 }]"
      @submit="save"
    >
      <div class="position-relative">
        <validate-form
          id="password"
          ref="password"
          v-model="password"
          vid="password"
          :type="showPassword ? 'text' : 'password'"
          :label="resource['resetPassword.newPassword']"
          :name="resource['resetPassword.newPassword']"
          rules="required"
          class-group="mb-2"
          @keyup.tab="focusChanged"
          @keypress="maxLengthCheck($event, 20, 'password')"
          @keyup="maxLengthCheck($event, 20, 'password')"
          @click="removePlaceHolder('password', password)"
          @blur="removeTitleGroup('password', password)"
          :placeholder="resource['resetPassword.newPassword']"
          autocomplete="off"
        >
        </validate-form>
        <h5
          class="show-password"
          :style="!password && 'cursor: initial'"
          @click="password && (showPassword = !showPassword)"
        >
          <img v-if="showPassword" :src="require('@/assets/images/show-password.svg')" />
          <img
            v-else
            :class="!password && 'show-password-icon'"
            :src="require('@/assets/images/hidden-password.svg')"
          />
        </h5>
      </div>

      <div class="mb-3">
        <div
          :class="[
            'd-flex align-items-center',
            {
              'color-grey-text': !passwordValidation.hasValidCount,
              'color-success': passwordValidation.hasValidCount,
            },
          ]"
        >
          <i class="icon-tick align-middle" />
          <h6>{{resource['resetPassword.PasswordCharacterErrorMessage']}}</h6>
        </div>
        <div
          :class="[
            'd-flex align-items-center',
            {
              'color-grey-text': !passwordValidation.hasSpecial,
              'color-success': passwordValidation.hasSpecial,
            },
          ]"
        >
          <i class="icon-tick align-middle" />
          <h6>{{resource['resetPassword.PasswordSpecialCharactersErrorMessage']}}</h6>
        </div>
        <div
          :class="[
            'd-flex align-items-center',
            {
              'color-grey-text': !passwordValidation.hasUpperCase,
              'color-success': passwordValidation.hasUpperCase,
            },
          ]"
        >
          <i class="icon-tick align-middle" />
          <h6>{{resource['resetPassword.AtLeastOneCapitalLetter']}}</h6>
        </div>
        <div
          :class="[
            'd-flex align-items-center',
            {
              'color-grey-text': !passwordValidation.hasNumber,
              'color-success': passwordValidation.hasNumber,
            },
          ]"
        >
          <i class="icon-tick align-middle" />
          <h6>{{resource['resetPassword.AtLeastOneNumber']}}</h6>
        </div>
      </div>

      <div class="position-relative">
        <validate-form
          id="confirmPassword"
          ref="confirmPassword"
          v-model="confirmPassword"
          vid="confirmPassword"
          :type="showConfirmPassword ? 'text' : 'password'"
          :label="resource['resetPassword.newPasswordAgain']"
          :name="resource['resetPassword.newPasswordAgain']"
          rules="required|confirmed:password"
          class-group="mb-3"
          @keyup.tab="focusChanged"
          @keypress="maxLengthCheck($event, 20, 'confirmPassword')"
          @keyup="maxLengthCheck($event, 20, 'confirmPassword')"
          @click="removePlaceHolder('confirmPassword', confirmPassword)"
          @blur="removeTitleGroup('confirmPassword', confirmPassword)"
          :placeholder="resource['resetPassword.newPasswordAgain']"
          autocomplete="off"
        />
        <h5
          class="show-password"
          :style="!confirmPassword && 'cursor: initial'"
          @click="
            confirmPassword && (showConfirmPassword = !showConfirmPassword)
          "
        >
          <img
            v-if="showConfirmPassword"
            :src="require('@/assets/images/show-password.svg')"
          />
          <img
            v-else
            :class="!confirmPassword && 'show-password-icon'"
            :src="require('@/assets/images/hidden-password.svg')"
          />
        </h5>
      </div>
    </form-wrapper>

    <div
      v-else
      :class="[
        'text-center reset-password-success',
        { 'animated fadeIn': status === 200 },
      ]"
    >
      <i class="icon-tick align-middle reset-password-success-icon" />

      <h3 class="text-center m-0">{{resource['resetPassword.SuccessPasswordTitle']}}</h3>
      <br />
      <h5 class="m-0">
        {{resource['forgotPassword.PassStepsDescThree']}}
      </h5>
      <br />
      <b-button
        type="submit"
        class="secondary-button w-100"
        @click="() => this.$router.push({ name: 'LoginView', params: { lang: $route.params.lang } })"
      >
        <loader v-show="isLoading" class="mr-2" />
        <img :src="require('@/assets/images/logo-white@3x.png')" />
        <b>  {{resource['resetPassword.MemberEnterButtonText']}}</b>
      </b-button>
    </div>

    <a
      v-if="status !== 200"
      class="secure-password-steps-link"
      @click="isStepMode = !isStepMode"
    >
      {{
        isStepMode
          ? 'Geri dön'
          : 'Güvenli şifre ipuçları hakkında detaylı bilgi'
      }}
    </a>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
// eslint-disable-next-line import/no-unresolved
// import mixins from '@/utils/mixins';
// import axios from 'axios';
// eslint-disable-next-line import/no-unresolved
import formEvents from '@/utils/formEvents';
import HrVenueService from '@/services/hrvenue.service';
import { showNotification } from '@/static/helpers';

export default {
  name: 'ResetPassword',

  layout: 'split',

  components: {
    FormWrapper: () => import('@/components/common/FormWrapper'),
    SecurePasswordSteps: () => import('../../common/SecurePasswordSteps.vue'),
  },

  mixins: [formEvents],

  data() {
    return {
      password: '',
      confirmPassword: '',
      currentPassword: '',
      showPassword: false,
      passwordValidation: {
        hasNumber: false,
        hasUpperCase: false,
        hasSpecial: false,
        hasValidCount: false,
      },
      isLoading: false,
      status: null,
      userName: '',
      isStepMode: false,
      showConfirmPassword: false,
      showCurrentPassword: false,
      forgotPasswordType: null,
    };
  },

  computed: {
    isValid() {
      return (
        this.password === this.confirmPassword && this.passwordValidation.hasNumber && this.passwordValidation.hasUpperCase && this.passwordValidation.hasSpecial && this.passwordValidation.hasValidCount
      );
    },
    account() {
      return this.$store.state.account;
    },

    enableButton() {
      return this.password.length > 0 || this.confirmPassword.length > 0;
    },
  },

  watch: {
    password(newVal) {
      this.validatePassword();
      if (!newVal) {
        this.showPassword = false;
      }
    },
    confirmPassword(newVal) {
      if (!newVal) {
        this.showConfirmPassword = false;
      }
    },
  },

  created() {
    // eslint-disable-next-line no-nested-ternary
    this.forgotPasswordType = this.$route.params.id ? (this.$route.params.uuid ? 1 : (this.$route.query.p ? 2 : null)) : null;
  },

  methods: {
    ...mapMutations({
      resetToken: 'account/RESET_TOKEN',
    }),

    validatePassword() {
      this.passwordValidation.hasNumber = /\d/.test(this.password);

      this.passwordValidation.hasUpperCase = this.password.replace(/[^A-Z]/g, '').length > 0;

      // eslint-disable-next-line no-useless-escape
      this.passwordValidation.hasSpecial = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password);

      this.passwordValidation.hasValidCount = this.password.length <= 20 && this.password.length >= 8;
    },

    async save() {
      if (this.isValid) {
        this.isLoading = true;
        const id = this.$route.params.id;
        const uuid = this.$route.params.uuid;
        const p = this.$route.query.p;
        const isFirstLogin = !uuid && p;

        const { changed } = await HrVenueService.changePassword(
          this.forgotPasswordType,
          id,
          uuid,
          this.forgotPasswordType === 2 ? p : this.currentPassword,
          this.password,
          this.confirmPassword,
        );
        if (changed) {
          localStorage.removeItem('pass');
          localStorage.removeItem('passwordLength');
          showNotification(
            this.resource['label.Success'],
            this.resource['resetPassword.ChangePassSuccessMessage'],
            'success',
          );
          const lang = this.$route.params.lang === 'en' ? '' : this.$route.params.lang;

          if (isFirstLogin) {
            this.$router.push({ name: 'LoginView', query: { redirect: '/pricing' }, params: { lang } });
          } else {
            this.$router.push({ name: 'LoginView', params: { lang } });
          }
        }
        this.isLoading = false;
      }
    },
    setWhichInput(InpEl, value) {
      if (InpEl === 'password') {
        this.password = value;
      } else if (InpEl === 'confirmPassword') {
        this.confirmPassword = value;
      }
    },
    maxLengthCheck(event, maxLength, inp) {
      const value = event.target.value;
      if (String(value).length <= maxLength) {
        this.setWhichInput(inp, value);
      } else {
        this.setWhichInput(inp, value.substring(0, maxLength));
        event.stopPropagation();
      }
    },
  },
//   head() {
//     return {
//       title: 'Kariyer.net',
//       meta: [
//         {
//           name: 'description',
//           content:
//             'Kariyer.net‘e ücretsiz üye olun, aradığınız elemana hemen ulaşın!',
//         },
//       ],
//     }
//   },
};
</script>

<style lang="scss" scoped>
@import "~@/style/design-kit/_variable.scss";

.reset-password-form,
.forgot-password-form {
  @media screen and (max-width: 612px) {
    width: 343px !important;
  }
  width: 360px;
  max-width: 100%;
  background: #fff;
  border-radius: 12px;
  padding: 0 16px 16px 16px;
  z-index: 1;
  margin-bottom: 20px;

  h2 {
    margin-bottom: 16px !important;
    margin-top: 20px;
  }

  .forgot-password-text {
    h6 {
      font-size: 14px !important;
    }
    color: $purple;

    &:hover {
      background-color: transparent !important;
      color: $secondary-purple !important;
      text-decoration: underline;
    }
  }

  .remember-me {
    margin: 10px 0 12px -6px !important;
    input {
      &:hover {
        cursor: pointer;
      }
    }
  }
}

.reset-password {
  &-form {
    .color-grey-text,
    .color-success {
      h6 {
        font-size: 12px !important;
      }
      .icon-tick.align-middle {
        margin-right: 5px;
        width: 10px;
        height: 10px;
        border: 1px solid $grey-text;
        border-radius: 50%;
        &::before {
          border: 0px;
        }
      }
    }

    .color-grey-text .icon-tick.align-middle::before {
      content: ' ';
    }

    .color-success .icon-tick.align-middle {
      border-color: #48ca77;
      &::before {
        color: #48ca77;
        display: block;
        text-align: center;
        margin-top: 0.25px;
        margin-left: 0.5px;
        font-size: 7px;
      }
    }
  }

  &-success {
    background: white;
    border-radius: 12px;
    padding: 15px;
    max-width: 360px;
  }

  &-success-icon {
    display: block;
    margin: 18px 0px 33px 0px;
    &::before {
      font-size: 35px;
      padding: 8px;
      border-radius: 50%;
      color: #48ca77;
      border: 5px solid #48ca77;
    }
  }
  .secondary-button {
    background-color: $purple !important;
    color: $white;

    &:hover {
      background-color: $secondary-purple !important;
      color: $white !important;
    }
    font-size: 14px;
    img {
      height: 17px;
    }
  }
  .d-flex.align-items-center {
    margin-bottom: 4px !important;
  }

  &.header-fix {
    margin-top: 105px !important;
    &.success-change {
      margin-top: -50px !important;
    }
  }
  .secure-password-steps-link {
    display: none;
  }
  @media screen and (max-width: 1140px) {
    .secure-password-steps-link {
      font-size: 14px;
      display: none;
      text-align: center;
      text-decoration: underline;
      color: white !important;
      cursor: pointer;
      &:hover {
        color: white;
      }
    }
    &.header-fix {
      margin-top: 0px !important;
      margin-bottom: 0px;
      &.success-change {
        margin-top: 0px !important;
        margin-bottom: 177px;
      }
    }
  }
  .show-password-icon {
    opacity: 0.5;
  }
  .form-container {
    display: flex;
    justify-content: center;
    flex-direction: column;
    form {
      .show-password {
        position: absolute;
        color: $grey-text;
        cursor: pointer;
        top: 0;
        right: 0;
      }
    }
  }

  .icon-tick {
    font-size: 12px !important;
  }
}
.responsive-logo {
  display: none;
  @media screen and (max-width: 1140px) {
    display: block;
    width: 260px;
    margin-bottom: 20px;
  }
  @media screen and (max-width: 612px) {
    margin-bottom: 15px !important;
  }
}
</style>
